/**
 * 프로필 사진(아바타) 등 이미지 경로를 공통으로 처리하는 유틸리티.
 * 로컬 정적 경로(/abata/...), 외부 URL(http/https), Base64 데이터(data:), blob: 도 통과시킵니다.
 */

export const DEFAULT_AVATAR = '/abata/abata_d_1.webp';

export function resolveImageUrl(value, fallback = null) {
  if (typeof value !== 'string' || !value.trim()) {
    return fallback;
  }
  
  const trimmed = value.trim();
  
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    return trimmed;
  }
  
  if (trimmed.startsWith('data:') || trimmed.startsWith('blob:')) {
    return trimmed;
  }
  
  if (trimmed.startsWith('/')) {
    return trimmed;
  }
  
  return `/abata/${trimmed}`;
}

export function resolveAvatarUrl(value) {
  return resolveImageUrl(value, DEFAULT_AVATAR);
}
